import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { Ingredient } from '@widgets/Ingredients/types'
import { printCSS } from '@utils/style'

const StyledWrapper = styled.div`
  ${({
    theme: {
      colors: {
        grey: { grey_30 },
      },
    },
  }) => {
    return css`
      display: grid;
      grid-template-columns: 30% 70%;
      align-items: center;
      width: 100%;
      min-height: 40px;
      border-bottom: 1px solid ${grey_30};
      word-wrap: break-word;
      ${printCSS(css`
        min-height: 24px;
        border-bottom: none;
      `)}
    `
  }}
`

const StyledText = styled.span`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => {
    return css`
      font-family: ${sourceSansPro};
      font-style: normal;
      font-size: 18px;
      line-height: 150%;
      letter-spacing: 0.01em;
      color: ${grey_100};
      ${printCSS(css`
        font-size: 14px;
        line-height: 18px;
      `)}
    `
  }}
`

const StyledAmount = styled(StyledText)`
  font-weight: 700;
`
const StyledIngredient = styled(StyledText)`
  font-weight: 500;
`

const IngredientItem: FunctionComponent<Ingredient> = ({
  amount,
  ingredient,
}) => (
  <StyledWrapper>
    {<StyledAmount>{amount || ''}</StyledAmount>}
    {ingredient && <StyledIngredient>{ingredient}</StyledIngredient>}
  </StyledWrapper>
)

export default IngredientItem
